const Sleep = (m) => new Promise((r) => setTimeout(r, m))

export default Sleep
